// extracted by css-extract-rspack-plugin
export default {"content":"Aml9x91___content","list":"Pl8jBUB___list"};